import { render, staticRenderFns } from "./BrandPage.vue?vue&type=template&id=4ca99e35&"
import script from "./BrandPage.vue?vue&type=script&lang=js&"
export * from "./BrandPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports